module.exports = __webpack_public_path__ + "fonts/JDSansPro-Boldd15ac6ca73c7d005ae01747ff3767d8e.woff2";